import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';

const LB_NAME_ANNOTATION = 'cloud.google.com/load-balancer';

const gcpLoadBalancerContent = EntityContentBlueprint.make({
  name: 'gcp-load-balancer',
  params: {
    path: '/load-balancer',
    title: 'Load Balancer',
    group: 'operation',
    filter: entity =>
      entity.kind.toLocaleLowerCase('en-US') === 'component' &&
      Boolean(entity.metadata.annotations?.[LB_NAME_ANNOTATION]),
    loader: () =>
      import('./GcpLoadBalancerContent').then(m => (
        <m.GcpLoadBalancerContent />
      )),
  },
});

export const gcpLoadBalancerModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [gcpLoadBalancerContent],
});
